// extracted by mini-css-extract-plugin
export default {"shares":"Shares_shares__xemZP","slider":"Shares_slider__pNEGy","sliderPicture":"Shares_sliderPicture__YOOZa"};